import {mutationTypes} from '@/core/constants'
import Vue from 'vue'
import {FileManagerUtils} from '@/core/utils'
import produto from '@/core/constants/produto'

export default {

    [mutationTypes.SET_COMPRA_DIRETA](state, compraDireta) {
        state.compraDireta = {
            ...compraDireta,
            documentosSolicitados: compraDireta.documentosSolicitados || [],
            linhasFornecimento: compraDireta.linhasFornecimento || []
        }
    },

    [mutationTypes.SET_ITENS_E_LOTES](state, itensELotes) {
        state.itensELotes = itensELotes
    },

    [mutationTypes.SET_DOCUMENTOS_SOLICITADOS](state, documentos) {
        state.documentosSolicitados = documentos
    },

    [mutationTypes.SET_DOCUMENTOS_PROPOSTA](state, documentos) {
        Vue.set(state, 'documentosProposta', documentos)
    },

    [mutationTypes.SET_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA](state, linhas) {
        state.linhasFornecimento = linhas
    },

    [mutationTypes.SET_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA](state, resumoProposta) {
        state.resumoProposta = resumoProposta
    },

    [mutationTypes.SET_USUARIO_LOGADO](state, usuario) {
        const user = {
            id: usuario.userId,
            name: usuario.userName,
            fullName: usuario.name,
            photo: FileManagerUtils.createThumbnailUrl(usuario.imageUrl),
            type: usuario.tipoUsuario,
            domainId: usuario.domainId,
            domainName: usuario.domainName,
            domainType: usuario.domainType,
            authorities: usuario.authorities
        }
        Vue.set(state.loki, 'user', user)
    },

    [mutationTypes.SET_PRODUTO](state, data) {
        state.loki.product.id = data.id
        state.loki.product.name = data.nome
        state.loki.product.mainLogo = FileManagerUtils.createUrl(data.atributosExtendidos.logoMenu)
        state.loki.product.symbolLogo = FileManagerUtils.createUrl(data.atributosExtendidos.logoMenuRetraido)
        state.loki.product.logoMobile = FileManagerUtils.createUrl(data.atributosExtendidos.logoMobile)
        state.loki.product.version = produto.VERSAO
        state.loki.product.copywrite = produto.COPYRIGHT
        state.loki.product.logoutUrl = produto.LOGOUT_URL
    },
}
